export const MAX_NUM_GRAPHIC = 1;
export const MAX_NUM_TEXT = 3;
export const MAX_NUM_MEMBERS = 10;
